'use strict'

module.exports = ccount

function ccount(value, character) {
  var count = 0
  var index

  value = String(value)

  if (typeof character !== 'string' || character.length !== 1) {
    throw new Error('Expected character')
  }

  index = value.indexOf(character)

  while (index !== -1) {
    count++
    index = value.indexOf(character, index + 1)
  }

  return count
}



//////////////////
// WEBPACK FOOTER
// ./~/ccount/index.js
// module id = 591
// module chunks = 95715928098905 168707334958949